import type { Theme } from '@mui/material';

import { brandBackground } from 'src/theme/brandBackground';

export const styles = {
  header: (theme: Theme) => ({
    background: brandBackground(theme),
    height: theme.dimension.headerHeight.xs,

    [theme.breakpoints.up('lg')]: {
      height: theme.dimension.headerHeight.lg,
    },
  }),
};
